<template>
	<section>
		<!-- Componentes externos -->
    <crear-persona />
    <editar-persona/>
    <aprobar-movilidad/>
    <h3 class="primary--text"><v-icon color="primary">business</v-icon> Lista de servidores públicos</h3>
		<v-card>
			<v-card-text>
				<crud-table
					:headers="headers"
          :url="url"
          :filters="filters"
          :data-graphql="dataGraphql"
					:graphql="graphql"
				>
					<!-- Template injectable de la cabecera de la tabla -->
					<template slot="buttons">
            <v-tooltip bottom>
             <v-btn color="primary" dark
               @click.native.stop="crearPersona()"
               slot="activator"
             ><v-icon dark>add</v-icon> {{$t('common.add') }}</v-btn>
             <span>Agregar persona</span>
           </v-tooltip>
          </template>

					<!-- Template de filas y columnas -->
					<template slot="items" slot-scope="items">
						<!-- Agregar las columnas que considere necesarias -->
            <td class="text-xs-center">{{ items.item.nro_doc }}</td>
            <td class="text-xs-center">{{ items.item.item }}</td>
            <td class="text-xs-center">{{ items.item.nombre }}</td>
            <td class="text-xs-center">{{ items.item.unidad }}</td>
            <td class="text-xs-center">{{ items.item.fecha_ingreso }}</td>
            <td class="text-xs-center">
              <v-chip color="success" text-color="white" v-if="items.item.id_estado === 1">{{ items.item.estado }}</v-chip>
              <v-chip color="error" text-color="white" v-if="items.item.id_estado === 32">{{ items.item.estado }}</v-chip>
              <v-chip color="error" text-color="white" v-if="items.item.id_estado === 2">{{ items.item.estado }}</v-chip>
              <v-chip color="orange" text-color="white" v-if="items.item.id_estado === 5">{{ items.item.estado }}</v-chip>
            </td>
            <td class="text-xs-center">
              <v-tooltip
                bottom
                v-if="items.item.id_estado === 1"
              >
                <v-btn
                  slot="activator"
                  color="red"
                  dark
                  @click.native="editarPersona(items.item)"
                  icon
                >
                  <v-icon>edit</v-icon>
                </v-btn>
                <span>Editar</span>
              </v-tooltip>
              <v-tooltip
                bottom
                v-if="items.item.id_estado === 1"
              >
                <v-btn
                  slot="activator"
                  color="green"
                  dark
                  icon
                  :to="`personas/ficha-personal/${items.item.id_persona}`"
                >
                  <v-icon>note</v-icon>
                </v-btn>
                <span>Ficha personal</span>
              </v-tooltip>
              <v-tooltip
                bottom
                v-if="items.item.id_estado === 1"
              >
                <v-btn
                  slot="activator"
                  color="blue"
                  dark
                  :to="`movilidad/${items.item.id_persona}`"
                  icon
                >
                  <v-icon>refresh</v-icon>
                </v-btn>
               
                <span>Movilidad</span>
              </v-tooltip>
              <v-tooltip
                bottom
                v-if="items.item.id_estado === 5"
              >
               
                <v-btn
                  slot="activator"
                  color="orange"
                  dark
                 
                  @click.native="aprobarMovilidad(items.item)"
                  icon
                >
                  <v-icon>check</v-icon>
                </v-btn>
                <span>Aprobar</span>
              </v-tooltip>
            </td>
          </template>

				</crud-table>
			</v-card-text>
		</v-card>
    <v-dialog
      v-model="dialog"
      width="400"
      persistent
    >
    
    <v-card
    color="#385F73"
    dark
    >
      <v-card-text>
        <v-layout wrap>
          <v-flex>
            <v-list-tile-content>
            
           <v-list-tile-title ><p color="red" >{{respuestaFuncion[0]}}</p></v-list-tile-title>
         
           <v-list-tile-title><p>{{respuestaFuncion[1]}}</p></v-list-tile-title>
           <v-list-tile-title><p>{{respuestaFuncion[2]}}</p></v-list-tile-title>
           </v-list-tile-content>   
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="success"
          @click.prevent="close()"
        >
        <v-icon>
          clear
        </v-icon>
        Cerrar
        </v-btn>  
      </v-card-actions>
    </v-card>
    </v-dialog>  
	</section>
</template>

<script>
import CrudTable from '@/common/util/crud-table/CrudTable.vue'; // Componente Tabla Dinámica
import crud from '@/common/util/crud-table/mixins/crud-table'; // Funciones y Metodos
import CrearPersona from './dialogs/CrearPersona' // Componente de creación y actualización
import EditarPersona from './dialogs/EditarPersona' // Componente de Editar persona
import AprobarMovilidad from './dialogs/AprobarMovilidad' // Componente de Aprobar Movilidad persona


export default {
	// Importación de métodos y funciones de un archivo mixin 
	mixins: [crud],
	// Variables iniciales del componente
	data () {
		return {
			url: 'vListaPersonals',
			graphql: true,
			// Cabecera de la tabla
			headers: [
        { text: 'Número de documento', value: 'nro_doc', align: 'center' },
        { text: 'Ítem', value: 'item', align: 'center' },
        { text: 'Nombre completo', value: 'nombre', align: 'center' },
        { text: 'Unidad', value: 'unidad', align: 'center' },
        { text: 'Fecha de incorporación', value: 'fecha_ingreso', align: 'center' },
        { text: 'Estado', value: 'id_estado', align: 'center' },
        { text: this.$t('common.actions'), sortable: false, align: 'center' }
      ],
			// Campos solicitados de Graphql(Agregar los que necesite)
			dataGraphql: `
        id_persona
        id_estado
        nro_doc
        nro_complemento
        item
        nombre
        unidad
        fecha_ingreso
        cargo
        id_cargo
        id_puesto
        id_item
        id_unidad
        id_movilidad
        estado
      `,
			filters: [
        {
          field: 'nro_doc',
          label: 'Número de documento',
          type: 'text',
          typeG: 'String'
        },
        {
          field: 'item',
          label: 'Ítem',
          type: 'number',
          typeG: 'String'
        },
        {
          field: 'nombre',
          label: 'Nombre completo',
          type: 'text',
          typeG: 'String'
        },
        {
          field: 'unidad',
          label: 'Unidad',
          type: 'text',
          typeG: 'String'
        },
        {
          field: 'fecha_ingreso',
          label: 'Fecha de incorporación',
          type: 'text',
          typeG: 'String'
        }
      ],
      respuestaFuncion:['usuario','correo','contraseña'],
      respuestaFuncion1:['usuario','correo','contraseña'],
      dialog:false
		}
	},
	// Funcionalidades que se ejecutan al montar el componente
  mounted () {
    // Verificando si el usuario tiene permiso para interactual con el componente
    const rolesPermitidos = [0] // ID's de roles permitidos
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push('/403')
    }
    this.onFilter();
    this.$bus.$on('closeDialog', () => {
      this.updateList()
    })
    this.$bus.$on('closeDialogCreado', item => {
      this.respuestaFuncion=item.split('-')
      //console.log(this.respuestaFuncion)
      this.dialog=true
    })
  },
	// Métodos y funciones del componente
	methods: {
    movilidad (item) {
      this.$bus.$emit('openDialogMovilidad', item)
    },
    editarPersona (item) {
      this.$bus.$emit('openDialogEditarPersona', item)
    },
     aprobarMovilidad (item) {
      this.$bus.$emit('openDialogAprobarMovilidad', item)
      //console.log(item)
    },
		crearPersona () {
			this.$bus.$emit('openDialogCrearPersona')
		},
    close(){
      this.respuestaFuncion=[]
      this.dialog=false
    }
	},
	// Definición de componentes importados
	components: {
		CrudTable,
		CrearPersona,
    EditarPersona,
    AprobarMovilidad
	}
}
</script>


<style>

</style>


// WEBPACK FOOTER //
// src/components/admin/persona/Index2.vue